import React, { createContext, useState, useContext } from 'react';
import MasonryWall from "components/shared/MasonryWall"
import MenuListingItem from "./MenuListingItem"

const DishContext = createContext();

const DishProvider = ({ children }) => {
    const [dishesOpen, setDishesOpen] = useState([]);

    // console.log(dishesOpen)
    
    return (
        <DishContext.Provider value={{ dishesOpen, setDishesOpen }}>
            {children}
        </DishContext.Provider>
    );
};

const ListingMenus = (props) => {
    let { items, dishDietFilters, dishAllergenFilters } = props
    
    return(  
        <DishProvider>
            <MasonryWall>
                {items.map(({node}, i) => {
                    const { dishes } = node.acfMenu
                    let filteredDishes = dishes
                    
                    // Filter dishes by diet and allergen
                    if (dishDietFilters?.length > 0) {
                        filteredDishes = filteredDishes?.filter(dish => {
                            // Check if the dish has all selected filters
                            return dish.dishDiets?.nodes?.length > 0 && dishDietFilters.every(filter => {
                                // Check if the filter is present in the dish's diets
                                return dish.dishDiets.nodes.some(dishDiet => dishDiet.databaseId === filter);
                            });
                        });
                    }

                    if (dishAllergenFilters?.length > 0) {
                        filteredDishes = filteredDishes?.filter(dish => {
                            return dish.dishAllergens?.nodes?.every(dishAllergen => {
                                // do not return the dish if it contains an allergen that is in the filter
                                return !dishAllergenFilters.some(filter => filter === dishAllergen.databaseId)
                            })
                        })
                    }

                    // only show menu if it has dishes
                    if (filteredDishes?.length > 0) {
                        return(
                            <MenuListingItem 
                                data={node} 
                                dishDietFilters={props.dishDietFilters}
                                dishAllergenFilters={props.dishAllergenFilters}
                                dishes={filteredDishes}
                                key={i}
                            />
                        )
                    } else return null
                })}
            </MasonryWall>
        </DishProvider>
    )
}

export default ListingMenus

export const useDishContext = () => useContext(DishContext);